module.exports = __webpack_public_path__ + "img/hys-9.2571208c.jpg";